import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { type AppointmentFormValuesWithRequiredFields } from '../../infra/ShipmentRepository'
import { updateAppointment } from '../../use-cases/updateAppointment'

type UpdateAppointmentParams = {
  shipmentUUID: string
  stopIndex: number
  data: AppointmentFormValuesWithRequiredFields
}

export function useUpdateAppointment() {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const update = useCallback(async ({ shipmentUUID, stopIndex, data }: UpdateAppointmentParams) => {
    setRequestStatus(RequestStatus.Pending)
    try {
      await updateAppointment({
        shipmentUUID,
        stopIndex,
        data,
      })
      setRequestStatus(RequestStatus.Done)
    } catch (error) {
      setRequestStatus(RequestStatus.Error)
    }
  }, [])

  return { update, requestStatus }
}
